import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import { useEffect, useState } from "react";

const MainBanner = () => {
    const { packageViewData, packageViewLoading } = useSafariPackagesContext();
    const [imageStatus, setImageStatus] = useState("loading");

    //check 
    useEffect(() => {
        if (!packageViewLoading && packageViewData?.image_banner_path) {
            const img = new Image();
            img.src = packageViewData?.image_banner_path;
            img.onload = () => setImageStatus("loaded");
            img.onerror = () => setImageStatus("error");
        }
    }, [packageViewLoading, packageViewData]);

    return (
        <div className="imagesSafari d-sm-block d-none">

            {packageViewLoading || imageStatus === "loading" ? (
                <div className="package-banner-dummy">

                </div>
            ) : imageStatus === "error" ? (
                <div className="package-banner-dummy">

                </div>
            ) : (
                <img
                    src={packageViewData?.image_banner_path}
                    alt="package-banner"
                    className="w-100"
                />
            )}
        </div>
    )
}

export default MainBanner;